// SVG Icons as components
export const DownloadIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

export const PlayIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="white"
    stroke="white"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="5 3 19 12 5 21 5 3"></polygon>
  </svg>
);

export const CheckmarkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect width="20" height="20" rx="10" fill="#002033" />
    <path
      d="M14.341 7.85651L13.9492 7.45583C13.7878 7.29077 13.5242 7.29077 13.3614 7.45583L9.25287 11.6588L7.10062 9.45785C6.93921 9.29277 6.67569 9.29277 6.51289 9.45785L6.12106 9.85854C5.95965 10.0236 5.95965 10.2931 6.12106 10.4596L8.95762 13.3603C9.03903 13.4436 9.14387 13.4859 9.25011 13.4859C9.35635 13.4859 9.46257 13.4436 9.54261 13.3603L14.3368 8.45756C14.5024 8.28968 14.5024 8.02161 14.341 7.85651Z"
      fill="white"
    />
  </svg>
);
